import { Directive, OnInit, TemplateRef } from '@angular/core';

import { ModalDialogComponent } from './modal-dialog.component';
import { Dialog } from '../../providers/modal/modal-types';


@Directive({ selector: '[vsfDialogButtons]' })
export class DialogButtonsDirective implements OnInit {
    constructor(private modal: ModalDialogComponent<void, Dialog<void>>, private templateRef: TemplateRef<void>) {}

    ngOnInit() {
        this.modal.registerButtonsTemplate(this.templateRef);
    }
}
